import { error } from "@/services/LoggerService";
import { State } from "@/store";
import { GetterTree } from "vuex";
import { AuthState } from "./state";

export type AuthGetters = {
  isAuthenticated(state: AuthState): boolean;
  getIdToken(state: AuthState): string;
  getUser(state: AuthState): any;
  getGroups(state: AuthState): Array<string>;
};

function isTokenExipired(exp?: number): boolean {
  try {
    if (!exp) {
      return true;
    }

    const expMiliSeconds: number = exp * 1000;
    return (expMiliSeconds - Date.now()) <= 0;
  } catch (e) {
    error(e);
    error(`Failed to check if token is expired, exp: ${JSON.stringify(exp)}`);
  }
  return true;
}

export const getters: GetterTree<AuthState, State> & AuthGetters = {
  isAuthenticated: (state) => {
    return !!state.idToken;
  },
  isExpired: (state) => {
    return isTokenExipired(state.exp);
  },
  getIdToken: (state) => {
    return state.idToken;
  },
  getUser: (state) => {
    return state.user;
  },
  getGroups: (state) => {
    return state.groups;
  },
};
